export const SplitByNum = (data: string, num: number = 4): string => {
    const newData = data?.trim()
    // const resultArray = [];
    let resultArray = "";
    for (let i = 0; i < newData.length; i++) {
      if (i % num === 0 && i !== 0) {
        // resultArray.push(" ");
        resultArray += " "
      }
    //   resultArray.push(newData[i]);
    resultArray += newData[i]
    }
    // return resultArray.join("")
    return resultArray;
  };

export const removeWhiteSpace = (cardNumber: string) => {
  const arr = cardNumber.trim()?.split(" ")
  console.log(cardNumber.trim()?.split(" "),"cardNumber.trim()?.split")
  return arr.join("");
};
